import React from 'react'
import styled from 'styled-components'

import complete from '../../../assets/images/complete.png'
import cancle from '../../../assets/images/cancle.png'

const Wrapper = styled.div<{ progress: number }>`
  padding-top: 20px;
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .progress-num {
    margin-left: 10px;
    width: 15px;
    height: 15px;
  }
  .cancle {
    cursor: pointer;
  }
  .progress-outer {
    height: 0.54rem;
    width: 100%;
    background: rgba(255, 205, 132, 0.3);
    border-radius: 0.32rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    .progress-inner {
      width: ${({ progress }) => progress + '%'};
      flex-shrink: 0;
      height: 0.54rem;
      background: ${({theme}) => theme.btnBg3};
      border-radius: 0.32rem;
    }
    /* .progress-img {
      width: 25px;
      height: 25px;
      margin-left: -8px;
    } */
  }
`

export default function ProgressWrapper({show, progress, cancelUpload}: {show: boolean, progress: number, cancelUpload?: () => void}) {
  return <>
    {
      show && <Wrapper progress={progress}>
        <div className="progress-outer">
          <div className="progress-inner"></div>
          {/* <img className="progress-img" src="/images/bakery/icon_bake.svg" alt=""/> */}
        </div>
        {
          progress > 0
            ? progress === 100
              ? <img className="progress-num" src={complete} alt=""/>
              : <img onClick={cancelUpload ? cancelUpload : () => {}} className="progress-num cancle" src={cancle} alt=""/>
            : <></>
        }
        
      </Wrapper>
    }
  </>
}
